import { listViewGridOption, listViewTreeGridOption } from '@/common/define/grid.define';
import { type DBType } from '@/common/utils';
import type { ChartData, GridColumn, GridOption, TreeGridOption } from '@/common/utils/types';

export type InstanceMonitoringType = 'Single View' | 'Multi View' | 'Detail' | 'Cluster View';
type UnambiguousDBType = NonNullable<DBType>;

export const INITIAL_CHART_DATA: ChartData = {
  series: {},
  labels: [],
  data: {},
};

export const DISPLAY_DB_TYPE = {
  ORACLE: 'Oracle',
  SQLSERVER: 'SQL Server',
  MYSQL: 'MySQL',
  POSTGRESQL: 'PostgreSQL',
  MONGODB: 'MongoDB',
  REDIS: 'Redis',
  CUBRID: 'CUBRID',
  ALTIBASE: 'Altibase',
  TIBERO: 'Tibero',
  CLICKHOUSE: 'ClickHouse',
  REDSHIFT: 'Amazon Redshift',
  SINGLESTORE: 'SingleStore',
} as const;

export const checkBoxGridOption: GridOption = {
  ...listViewGridOption,
  useCheckbox: {
    use: true,
    mode: 'multi',
    headerCheck: true,
  },
};

export const checkBoxTreeGridOption: TreeGridOption = {
  ...listViewTreeGridOption,
  useCheckbox: {
    use: true,
    mode: 'multi',
    headerCheck: true,
  },
};

export const DATABASE_SINGLE_VIEW_TYPES: Partial<
  Record<UnambiguousDBType, InstanceMonitoringType>
> = {
  mysql: 'Single View',
  postgresql: 'Single View',
  sqlserver: 'Single View',
  // altibase: 'Single View', // 일단 가림 (대시보드 연계 필요)
  // cubrid: 'Single View', // NOTE: 대시보드 구성안됨
} as const;

export const DATABASE_MULTI_VIEW_TYPES: Partial<Record<UnambiguousDBType, InstanceMonitoringType>> =
  {
    oracle: 'Multi View',
    mysql: 'Multi View',
    postgresql: 'Multi View',
    // cubrid: 'Multi View', // NOTE: 대시보드 구성안됨
    altibase: 'Multi View',
  } as const;

export const DATABASE_CLUSTER_VIEW_TYPES: Partial<
  Record<UnambiguousDBType, InstanceMonitoringType>
> = {
  singlestore: 'Cluster View',
} as const;

export const RATIO_BAR_COLUMN = ['cpuUsage', 'memoryUsage'];

export const IMMEDIATE_SEARCH_FROM = {
  DETAIL: 'detail',
  DASHBOARD: 'dashboard',
} as const;

export const MINIMAL_INTERVAL = 'I1m';

export const CLUSTER_DIFF_KEY: Partial<Record<UnambiguousDBType, string>> = {
  singlestore: 'singlestoreClusterId',
};

// MySQL, PG SingleView
export const TOP_5_GRID_OPTIONS: GridOption = {
  adjust: true,
  useFilter: false,
  rowMinHeight: 20,
  scrollWidth: 8,
  showHeader: false,
  hiddenColumnMenuItem: {
    filter: true,
  },
  style: {
    border: 'none',
    highlight: 0,
  },
};

export const TOP_5_DIFF_STATISTICS_GRID_COLUMNS: GridColumn[] = [
  {
    caption: 'Rank',
    field: 'rank',
    type: 'number',
    width: 65,
  },
  {
    caption: 'Name',
    field: 'name',
    type: 'string',
  },
  {
    caption: 'DiffRatio',
    field: 'diffRatio',
    type: 'number',
  },
  {
    caption: 'DiffValue',
    field: 'diffValue',
    type: 'number',
  },
  {
    caption: 'DataID',
    field: 'dataId',
    type: 'string',
    hide: true,
  },
];

export const STAT_CHANGE_TREE_GRID_OPTION: TreeGridOption = {
  showHeader: false,
  useFilter: true,
  rowHeight: 36,
  style: {
    border: 'none',
    highlight: -1,
  },
  parentIcon: 'none',
  childIcon: 'none',
};
